import { Link } from 'gatsby'
import React from 'react'
import Navigation from 'react-sticky-nav'

import Logo from '../logo/logo'
import './header.css'

const Header = ({ headerColor, navItems, disabled }) => {
  const items = navItems
    ? navItems.map(item => ({
        url: item.slug.current,
        title:
          item.config && item.config.navigationTitle ? item.config.navigationTitle : item.title,
      }))
    : []
  return (
    <Navigation
      className={'amHeader ' + (disabled ? 'disabled ' : '') + headerColor}
      disabled={disabled}
    >
      <div className="inner">
        <Link to="/" className="home" title="home">
          <Logo></Logo>
        </Link>
        {items.length > 0 && (
          <ul>
            {items.map(item => (
              <li key={item.title}>
                <Link to={item.url}>{item.title}</Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </Navigation>
  )
}

export default Header
